import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import { AccountJoinContainer } from './AccountJoinContainer'

export const AccountJoinLoading = () => {
  return (
    <AccountJoinContainer title="Loading..." description={<p>Retrieving user information...</p>}>
      <Icon name="circle-notch" className="fa-5x text-info fa-spin" />
    </AccountJoinContainer>
  )
}
